import ImpersonateBar from './components';

export default ImpersonateBar;
